export const ADMISSION_ENTER_ROUTE = "/workflow/enter";
